import { Link } from "react-router-dom";

const entries = [
  {
    to: "/movie",
    title: "电影",
    subtitle: "动作 · 爱情 · 科幻 · 悬疑",
    desc: "海量院线大片与经典佳作，高清畅享",
    image:
      "https://readdy.ai/api/search-image?query=Cinema%20hall%20with%20rows%20of%20glowing%20seats%20and%20a%20bright%20screen%20in%20deep%20blue%20ambient%20light%2C%20warm%20projector%20glow%2C%20modern%20minimal%20cinematic%20mood&width=800&height=500&seq=entry-movie&orientation=landscape",
    icon: "ri-film-line",
    accent: "bg-primary-500",
  },
  {
    to: "/tv",
    title: "电视剧",
    subtitle: "国产 · 欧美 · 日韩 · 港台",
    desc: "热播剧集持续更新，追剧不等待",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20at%20evening%20with%20a%20large%20smart%20TV%20showing%20a%20warm%20glowing%20scene%2C%20soft%20amber%20lamp%20light%20and%20deep%20blue%20shadows%2C%20modern%20minimal%20interior&width=800&height=500&seq=entry-tv&orientation=landscape",
    icon: "ri-tv-2-line",
    accent: "bg-accent-500",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative block h-44 md:h-52 rounded-lg overflow-hidden"
        >
          <img
            src={entry.image}
            alt={entry.title}
            title={`${entry.title}频道 - 91视频免费看`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/10"></div>
          <div className="absolute inset-0 flex items-center gap-5 px-6 md:px-8">
            <span className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg ${entry.accent} text-white shrink-0`}>
              <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white">{entry.title}</h3>
              <p className="mt-1 text-xs md:text-sm text-white/75 truncate">{entry.subtitle}</p>
              <p className="mt-2 text-sm text-white/90 flex items-center gap-1">
                {entry.desc}
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}